import {environment} from '@env/environment';

export const DEFAULT_DISTRICT_PARENT_DOMAIN = (environment.customer['defaultDistrictParentDomain'] || '.sp.gg4l.com');
export const HOST_COURSERA = 'coursera.gg4l.com';
export const HOST_QWIKLABS = 'qwiklabs.gg4l.com';
export const HOST_AMPLIFY = 'amplify.gg4l.com';

export interface IEtxHost {
    hostId: number;
    hostName: string;
}
